<main class="main mt-3">
  <div class="content">
    <div class="left-side" *ngIf="!isPreview">
      <div class="d-flex justify-content-between align-items-center mb-3">
        <div>Push:</div>
        <div class="remove-block-button">
          <a class="btn btn-sm" (click)="removeBlock()"
            ><i class="bi bi-trash-fill remove-block-icon"></i
          ></a>
        </div>
      </div>
      <div class="row">
        <div class="col-6">
          <app-block-text
            [type]="'content'"
            (handleOnChange)="onChange($event, 'PushCopy')"
            [blockData]="block.variables?.PushCopy ?? ''"
            [placeholder]="pushCopyPlaceHolder"
            [maxLength]="4000"
            variable="PushCopy"
          ></app-block-text>
        </div>
        <div class="col-6">
          <app-block-text
            [type]="'link'"
            (handleOnChange)="onChange($event, 'PushLink')"
            [blockData]="block.variables?.PushLink ?? ''"
            [placeholder]="pushLinkPlaceHolder"
            [maxLength]="4000"
            variable="PushLink"
          ></app-block-text>
        </div>
      </div>

      <div class="row">
        <div class="col-6">
          <app-block-text
            [type]="'content'"
            (handleOnChange)="onChange($event, 'PushSubject')"
            [blockData]="block.variables?.PushSubject ?? ''"
            [placeholder]="pushSubjectPlaceHolder"
            [maxLength]="4000"
            variable="PushSubject"
          ></app-block-text>
        </div>
        <div class="col-6">
          <app-block-text
            [type]="'content'"
            (handleOnChange)="onChange($event, 'PushTitle')"
            [blockData]="block.variables?.PushTitle ?? ''"
            [placeholder]="pushTitlePlaceHolder"
            [maxLength]="4000"
            variable="PushTitle"
          ></app-block-text>
        </div>
      </div>
    </div>
    <div
      class="right-side-container"
      [id]="block.blockId"
      (click)="onContainerClick($event)"
    >
      <app-pin [block]="block"></app-pin>
      <div class="right-side push-text">
        <a target="_blank" [href]="helper.getFullUrl($safeNavigationMigration(block.variables?.PushLink))">
          <div class="push-container p-3">
          <div class="row text-background align-items-start p-2">
            <div class="col-auto">
              <img
                src="/assets/images/valamar_shell_60x60.jpg"
                class="valamar-shell-logo mt-2"
              />
            </div>
            <div id="text-content" class="col-9">
              <div>
                <p class="time-text mb-1" [innerHTML]="currentTime"></p>
              </div>
              <div>
                <p
                  class="mb-1"
                  [innerHTML]="$safeNavigationMigration(block.variables?.PushTitle)"
                  style="font-size: 18px; font-weight: 500"
                ></p>
              </div>
              <div>
                <p
                  [innerHTML]="$safeNavigationMigration(block.variables?.PushCopy)"
                  style="font-size: 16px"
                ></p>
              </div>
            </div>
          </div>
        </div>
        </a>
      </div>
    </div>
    <div class="comments-side" *ngIf="!isPreview">
      <app-notification
        [notifications]="block.notifications"
        [blockId]="block.blockId"
      ></app-notification>
    </div>
  </div>
</main>
